export default "__VITE_ASSET__353ac608__"